import { useCallback } from 'react'

import instance from 'api/v1'
import { useAuth } from 'hooks/useAuth'
import { createSnackbar } from 'utils/createSnackbar'

export const useEditHomeMeta = () => {
  // @ts-ignore
  const { user } = useAuth()
  const apiInstance = instance(user)

  return useCallback((state: any, id: number) => {
    const fetch = async () => {
      await apiInstance.post(`/general-pages/${id}`, state, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          createSnackbar('Home page meta tags updated successfully')
        })
        .catch((error) => {
          console.error(error)
          if (error.response) createSnackbar(error.response.data.message)
          else createSnackbar('Something went wrong')
        })
    }
    fetch()
  }, [])
}
